import { Button, Card } from "@/src/components";
import { useStake } from "@/src/hooks/useStake";
import { ReloadIcon } from "@/src/icons";
import { useRebase } from "@/src/context";
import { toast } from "react-hot-toast";
import { useAccount } from "wagmi";
import { useState, useEffect, useRef } from "react";
import { useBalances } from "@/src/hooks/useBalances";
import { activeChain } from "@/src/configs/chainConfig";

export const RebaseButton = () => {
  const { chain } = useAccount();
  const [rebaseInterval, setRebaseInterval] = useState(0);
  const [lastRebaseTime, setLastRebaseTime] = useState(0);
  const [rebaseRate, setRebaseRate] = useState(0);
  const {stakeBalance} = useBalances();
  const [timeCheck, setTime] = useState(0);
  const{timeCheck: timeCheckProp} = useState(new Date());
  const { rebaseInterval: rebaseIntervalProp, lastRebaseTime: lastRebaseTimeProp, rebaseRate: rebaseRateProp} = useRebase();
  useEffect(() => {
    setRebaseInterval(parseInt(rebaseIntervalProp));
    setLastRebaseTime(parseInt(lastRebaseTimeProp));
    setRebaseRate(parseFloat(rebaseRateProp));
    setTime(timeCheckProp);
  }, [rebaseIntervalProp, lastRebaseTimeProp, rebaseRateProp, timeCheckProp]);
  const { isConnected } = useAccount();
  const { onRebase } = useStake();
  const [isValid, setValid] = useState(false);

  const [{ isCorrectChain }, setState] = useState({
    isCorrectChain: true,
  });

  useEffect(() => {
    if (isConnected)
      setState({
        isCorrectChain: chain?.id === Number(activeChain.chainId),
      });
    
  }, [chain, isConnected]);

  const validate = () => {
    if (stakeBalance == 0){
      return false;
    }
    if (!isCorrectChain){
      return false;
    }
    if(lastRebaseTime > 0){
      return Date.now()/1000 > (lastRebaseTime + rebaseInterval);

    }else{return true;}
  };
  useEffect(() => {
    const isValid = validate();
    setValid(isValid);
  }, [lastRebaseTime, rebaseInterval, timeCheck]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const handleRebase = async () => {
    if (!isConnected) return;

    toast.promise(onRebase(), {
      loading: "Transaction is in progress",
      success: "Successfully harvested CRB",
      error: (data) => data,
    });
  };
  return (
    <Card className="h-1/5">
      <div className="flex items-center h-full">
        <Button onClick={handleRebase} className="" disabled>
          <ReloadIcon className="h-7 w-8 text-foreground" />
          <h2 className="md:text-2xl text-xl text-foreground">Harvest</h2>
        </Button>
        {}
      </div>
    </Card>
  );
};
